let load = require('./helpers/browser/esm-js-loader-shards')(4);
module.exports = (load("3A6dW")).then(() => parcelRequire('38qbF'));